// extracted by mini-css-extract-plugin
export default {"NewProjectPage":"NewProjectPage_NewProjectPage__sfWjN","pageRow":"NewProjectPage_pageRow__F42gw"};